var render = function render(){var _vm=this,_c=_vm._self._c;return _c('transition',{attrs:{"name":"lazy-component"}},[(_vm.isInit)?_c('div',{key:"component"},[_vm._t("default",null,{"loading":_vm.loading})],2):(_vm.$slots.skeleton)?_c('div',{key:"skeleton"},[_vm._t("skeleton")],2):_c('div',{key:"loading"})])
}
var staticRenderFns = []

export { render, staticRenderFns }